module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/pdf-0f14cd42f9883257c9fcb3a7d5012e0d.svg";